import {Location} from '../../../locations/shared/model/location';

export interface LocationsState {
  locations: Location[];
}

export const initialLocationsState: LocationsState = {
  locations: [],
};
